<template>
  <ul class="listOfProducts">
    <li v-if="products.length === 0" class='no-products'>
      <div>
        No products to show :(
      </div>
      <router-link to="/">
        <btn class="btn-small btn-white">
          Reset filters
        </btn>
      </router-link>
    </li>
    <transition-group name="list-complete" mode="out-in">
    <li v-for="product in products" :key="product.name">
      <router-link :to="'/product/'+product.uid" class="product white-bg">
        <div class="product-image">
           <img :src="product.image" :alt="product.name">
        </div>
        <ul class="disciplines">
          <li v-for="(discipline, index) in product.disciplines" :key="index"
           :class="discipline">
            {{ discipline }}
          </li>
        </ul>
        <h2 class="product-name">
          {{ product.name.replace("SABFOIL ", "") }}
        </h2>

        <div class="product-price">
          <span class="price" v-if="product.price" :class="{strikethrough: product.deal_price}">
            CHF {{ product.price }}.-
          </span>
          <span class='stock-status-color' v-if="!product.deal_price"
          :class="{'in-stock': product.in_stock}">
          </span>
          <span class='deal-price' v-if="product.deal_price">
            CHF {{ product.deal_price }}.-
          </span>
          <span class='deal-sticker' v-if="product.deal_price">
            {{product.used ?  "Used" : "Deal"}}
            {{product.price ? " –" +
            Math.round(100*(product.price-product.deal_price)/product.price)
             + "%" : ""}}
          </span>
        </div>


        <!-- Add to cart button -->
        <!-- <btn btnColor="btn btn-large btn-sucess"
            :cartIcon="true"
            @click.native="addProductToCart(product)">
          Add to cart
        </btn> -->
      </router-link>
    </li>
    </transition-group>
  </ul>
</template>

<script>
import { mapActions } from 'vuex';
import btn from './Btn';

export default {
  props: ['products'],

  components: {
    btn,
  },
  methods: {
    ...mapActions([
      'addProduct',
    ]),

    addProductToCart(product) {
      this.addProduct(product);
    },
  },
};
</script>

<style scoped>

  .listOfProducts {
    width: 100%;
    max-width: 1080px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 0;
    list-style: none;
    padding-bottom: 4em;
  }

  .listOfProducts > span {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-around;
    margin: 0 auto;
    padding: 1em;
    gap: 2em;
  }

  /* List transitions: https://vuejs.org/v2/guide/transitions.html#List-Transitions */
  .listOfProducts li {
    display: inline-block;
    transition: all .4s;
    flex-grow: 1;
  }
  .list-enter-active, .list-leave-active {
    transition: all .4s;
  }
  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .list-complete-item {
    transition: all .4s;
    display: inline-block;
  }
  .list-complete-enter, .list-complete-leave-to
  /* .list-complete-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .list-complete-leave-active {
    position: absolute;
  }

  .product {
    background-color: #fff;
    list-style: none;
    box-sizing: border-box;
    padding: 1em 1.5em;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 7px;
    overflow: hidden;
    transition: all 0.3s;
    position: relative;
    height: 100%;
    justify-content: space-between;
  }

  .product.white-bg:hover {
    box-shadow:
      0 3.3px 5.3px rgba(0, 0, 0, 0.08),
      0 11.2px 17.9px rgba(0, 0, 0, 0.12),
      0 50px 80px rgba(0, 0, 0, 0.2)
    ;
  }

  .product:hover .product-name, .product:hover .product-price{
    color: #828891;
  }

  .product-name {
    font-size: 1.2em;
    font-weight: normal;
    text-align: left;
    width: 100%;
    transition: all 0.3s;
  }

  .product-price {
    margin-top: -0.4em;
    margin-bottom: 0.1em;
    transition: all 0.3s;
    gap: 0.375em 0.5em;
  }

  .product-image {
    width: 250px;
    height: 250px;
    display: flex;
    justify-content: space-around;
   }
   .product-image > img {
     height: 100%;
   }

  .disciplines {
    position: absolute;
    right: 1.2em;
    flex-direction: column;
    gap: 5px;
  }

  .listOfProducts li.no-products {
    flex-grow: 0;
    margin-top: 6em;
    display: flex;
    flex-direction: column;
    align-content: center;
  }

  .listOfProducts li.no-products a {
    margin: 1em auto 0;
  }

  .listOfProducts li.no-products button {
    margin: 0;
  }

  .listOfProducts > span > li:last-child .product {
    /* Half width */
    max-width: 508px;
  }

  @media screen and (max-width: 1000px) {
    .listOfProducts > span > li {
      flex-basis: 40%
    }
  }

  @media screen and (max-width: 670px) {
    .listOfProducts > span {
      gap: 1.5em;
    }
  }

  @media screen and (min-width: 1001px) {
    .product {
      max-width: 565px; /* 508px for 50% of width */
    }
    /* .listOfProducts > span > li {
      Uncomment to have all product boxes at the same size
      flex-basis: 30%
    } */
  }

</style>



// WEBPACK FOOTER //
// src/components/ListOfProducts.vue